import { messages } from 'vee-validate/dist/locale/en.json';

export const en: Record<string, string> = {
  ...messages,
  max: '{_field_} may not be greater than {length} characters.',
  min_value: '{_field_} must be greater than {_value_}.',
  required: 'Enter {_field_}.'
};
